import type { SetPrescription, MeasureType, WeightUnit } from '../store/types';
import { fmtSet, inferMeasure } from '@fitflex/shared';

// Pure set parse/format helpers now live in @fitflex/shared (shared with mobile).
export { setToText, parseSet, MEASURE_LABELS, normalizeLoad, inferMeasure, fmtSet } from '@fitflex/shared';

// Coach-level default weight unit (per device; per-exercise override persists in data).
export const getDefaultUnit = (): WeightUnit =>
  (typeof localStorage !== 'undefined' && localStorage.getItem('fitflex_unit') === 'kg') ? 'kg' : 'lb';
export const setDefaultUnit = (u: WeightUnit): void => localStorage.setItem('fitflex_unit', u);

// Convenience: format a whole exercise's sets with its (possibly inferred) presentation.
export const fmtSets = (
  sets: SetPrescription[],
  measure?: MeasureType,
  unit?: WeightUnit,
  sep = ' · '
): string => {
  const m = measure ?? inferMeasure(sets);
  const u = unit ?? getDefaultUnit();
  return sets.map((s) => fmtSet(s, m, u)).filter(Boolean).join(sep);
};
